/**
 * Copyright IBM Corp. 2022, 2026
 */

import { defineRouting } from 'next-intl/routing'
import { createNavigation } from 'next-intl/navigation'
import { SUPPORTED_LOCALES } from '@web/utils/i18n/constants'

export const routingConfig = {
	// A list of all locales that are supported
	locales: SUPPORTED_LOCALES,

	// Used when no locale matches
	defaultLocale: 'en',
} as const

type SiteLocale = (typeof routingConfig.locales)[number]

export const routing = defineRouting(routingConfig)

export const isSiteLocale = (locale: string): locale is SiteLocale => {
	return routingConfig.locales.includes(locale as SiteLocale)
}

// Lightweight wrappers around Next.js' navigation APIs
// that will consider the routing configuration
export const { Link, redirect, usePathname, useRouter } =
	createNavigation(routing)
